import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API_URLS } from '../../apiConfig';
import EditPersonForm from './EditPersonForm'; 

//const API_BASE_URL = 'https://scagliacons.cloud/api/personas';

function PersonasList({ refreshKey }) {
    const [personas, setPersonas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [editingPerson, setEditingPerson] = useState(null); 
    const [searchTerm, setSearchTerm] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const fetchFilteredPersonas = useCallback(async (term = searchTerm) => {
        const trimmedTerm = term.toLowerCase().trim();
        if (!trimmedTerm) {
            setPersonas([]);
            if (refreshKey === 0) setError('Ingrese un nombre para buscar.');
            return;
        }

        try {
            setLoading(true);
            setError(null);
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_URLS.PERSONAS}?search=${trimmedTerm}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            const filtered = response.data.filter(p => 
                (p.nombre?.toLowerCase().includes(trimmedTerm)) ||
                (p.apellido?.toLowerCase().includes(trimmedTerm)) ||
                (p.correo?.toLowerCase().includes(trimmedTerm))
            );

            setPersonas(filtered); 
            if (filtered.length === 0) setError(`No hay resultados para "${trimmedTerm}".`);
        } catch (err) {
            setError('Error de conexión.');
        } finally {
            setLoading(false);
        }
    }, [searchTerm, refreshKey]);

    useEffect(() => {
        if (refreshKey > 0) fetchFilteredPersonas();
    }, [refreshKey, fetchFilteredPersonas]);

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        fetchFilteredPersonas();
    };

    const handlePrintAll = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(API_URLS.PERSONAS, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const all = response.data;
            const rolLabel = { administrador: 'Administrador', usuario_stock: 'Usuario Stock', retiro_mercaderia: 'Retiro Mercadería' };
            const filas = all.map(p => `
                <tr>
                    <td>${p.nombre} ${p.apellido}</td>
                    <td>${rolLabel[p.rol] || p.rol}</td>
                    <td>${p.correo || '---'}</td>
                    <td>${p.numero_contacto || '---'}</td>
                </tr>
            `).join('');
            const ventana = window.open('', '_blank');
            ventana.document.write(`
                <html>
                <head>
                    <title>Listado de Personal</title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 30px; color: #333; }
                        h1 { font-size: 20px; border-bottom: 3px solid #333; padding-bottom: 10px; margin-bottom: 5px; }
                        .subtitle { font-size: 12px; color: #666; margin-bottom: 20px; }
                        table { width: 100%; border-collapse: collapse; }
                        th { background: #1a1a1a; color: #FFD700; padding: 10px 8px; text-align: left; font-size: 12px; text-transform: uppercase; }
                        td { padding: 9px 8px; border-bottom: 1px solid #eee; font-size: 13px; }
                        tr:nth-child(even) td { background: #f9f9f9; }
                        .total { margin-top: 15px; font-size: 12px; color: #999; }
                        @media print { button { display: none; } }
                    </style>
                </head>
                <body>
                    <h1>Listado Completo de Personal</h1>
                    <div class="subtitle">Fecha: ${new Date().toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' })}</div>
                    <table>
                        <thead>
                            <tr>
                                <th>Nombre Completo</th>
                                <th>Rol</th>
                                <th>Correo</th>
                                <th>Contacto</th>
                            </tr>
                        </thead>
                        <tbody>${filas}</tbody>
                    </table>
                    <div class="total">Total registros: ${all.length}</div>
                </body>
                </html>
            `);
            ventana.document.close();
            setTimeout(() => ventana.print(), 500);
        } catch (err) {
            console.error('Error al imprimir listado:', err);
        }
    };

    const handleDelete = async (id, nombre) => {
        if (window.confirm(`¿Seguro que desea eliminar a ${nombre}?`)) {
            try {
                await axios.delete(`${API_URLS.PERSONAS}/${id}`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                });
                fetchFilteredPersonas(); 
                setSuccessMessage(`Registro eliminado.`);
                setTimeout(() => setSuccessMessage(''), 3000);
            } catch (err) {
                setError('No se pudo eliminar el registro.');
            }
        }
    };

    return (
        <div className="form-container-responsive animate-fadeIn">
                       {/* Sección de Búsqueda con Encabezado */}
            <div className="bg-white p-6 rounded-[2rem] shadow-sm border border-gray-100 mb-8">
               <div className="mb-6">
            <span className="text-[10px] font-black text-gray-400 uppercase tracking-[0.3em] block mb-1">
                Filtro de Seguridad
                </span>
                <h2 className="text-2xl font-bold text-gray-800">
                     Gestión de <span className="border-b-4 border-[#FFD700]">Personal</span>
                </h2>
            </div>

                <form onSubmit={handleSearchSubmit} className="flex flex-col md:flex-row items-end gap-4">
                    <div className="relative flex-grow w-full">
                        <label className="text-xs font-bold text-gray-600 mb-2 block ml-1">
                            Buscar por Nombre, Apellido o Documento
                        </label>
                        <div className="relative">
                            <span className="absolute inset-y-0 left-0 pl-4 flex items-center text-gray-400">
                                <i className="bi bi-search text-sm"></i>
                            </span>
                            <input
                                type="text"
                                className="w-full pl-11 pr-4 py-2.5 bg-gray-50 border border-transparent rounded-xl focus:bg-white focus:border-[#FFD700] focus:ring-0 transition-all duration-300 text-sm font-medium text-gray-700 placeholder:text-gray-300"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder="Ej: Juan Pérez..."
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={loading || !searchTerm.trim()}
                        className="btn-corporate py-2.5 px-8 text-xs uppercase tracking-widest min-h-[45px] mb-[2px]"
                    >
                        {loading ? '...' : 'Consultar'}
                    </button>

                    <button
                        type="button"
                        onClick={handlePrintAll}
                        className="flex items-center gap-2 py-2.5 px-6 bg-gray-800 text-white rounded-xl text-xs uppercase tracking-widest font-bold hover:bg-gray-700 transition-all min-h-[45px] mb-[2px]"
                        title="Imprimir listado completo de personal"
                    >
                        <i className="bi bi-printer"></i>
                        Imprimir Todo
                    </button>
                </form>
            </div>

            {/* Mensajes de Estado */}
            {successMessage && (
                <div className="bg-gray-900 text-[#FFD700] p-4 rounded-2xl mb-6 flex items-center shadow-lg animate-bounce">
                    <i className="bi bi-check-circle-fill me-3"></i> {successMessage}
                </div>
            )}
            
            {error && !loading && (
                <div className="text-center py-12 bg-gray-50 rounded-[2.5rem] border-2 border-dashed border-gray-200">
                    <i className="bi bi-person-exclamation text-gray-300 text-5xl mb-4 block"></i>
                    <p className="text-gray-500 font-medium">{error}</p>
                </div>
            )}

            {/* Listado en Grid */}
            {!loading && personas.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {personas.map((persona) => (
                        <div key={persona.id} className="bg-white p-6 rounded-[2rem] shadow-sm border border-gray-100 hover:shadow-xl hover:border-gray-200 transition-all group flex justify-between items-center">
                            <div className="flex gap-5 items-center">
                                {/* Avatar con inicial en Amarillo/Negro */}
                                <div className="w-14 h-14 bg-gray-900 text-[#FFD700] rounded-2xl flex items-center justify-center font-bold text-2xl shadow-inner transform group-hover:rotate-3 transition-transform">
                                    {persona.nombre.charAt(0)}
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-gray-800 leading-tight">
                                        {persona.nombre} {persona.apellido}
                                    </h4>
                                    <span className="inline-block px-2 py-0.5 bg-gray-100 text-gray-500 text-[10px] font-bold uppercase tracking-wider rounded-md mb-2">
                                        {persona.rol.replace('_', ' ')}
                                    </span>
                                    <div className="text-sm text-gray-400 space-y-1">
                                        <p className="flex items-center gap-2"><i className="bi bi-envelope"></i>{persona.correo || '---'}</p>
                                        <p className="flex items-center gap-2"><i className="bi bi-telephone"></i>{persona.numero_contacto || '---'}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Acciones Modernas con Texto descriptivo */}
                                <div className="flex flex-col gap-3 min-w-[120px]">
                                    <button 
                                        onClick={() => setEditingPerson(persona)}
                                        className="flex items-center justify-center gap-2 px-4 py-2 bg-gray-50 text-gray-700 font-bold rounded-xl hover:bg-[#FFD700] hover:text-black transition-all border border-gray-100 shadow-sm text-xs uppercase tracking-wider"
                                    >
                                        <i className="bi bi-pencil-square"></i>
                                        <span>Editar</span>
                                    </button>
                                    
                                    <button 
                                        onClick={() => handleDelete(persona.id, persona.nombre)}
                                        className="flex items-center justify-center gap-2 px-4 py-2 bg-red-50 text-red-600 font-bold rounded-xl hover:bg-red-600 hover:text-white transition-all border border-red-100 shadow-sm text-xs uppercase tracking-wider"
                                    >
                                        <i className="bi bi-trash3"></i>
                                        <span>Eliminar</span>
                                    </button>
                                </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Modal de Edición */}
            {editingPerson && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-[3rem] w-full max-w-2xl overflow-hidden shadow-2xl animate-fadeIn">
                        <EditPersonForm 
                            person={editingPerson}
                            setEditingPerson={setEditingPerson}
                            onUpdate={() => {
                                fetchFilteredPersonas();
                                setSuccessMessage('¡Usuario actualizado!');
                                setTimeout(() => setSuccessMessage(''), 3000);
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default PersonasList;